/* SIXDAYS PDP enhancement (progressive enhancement only).
   The server rendered engraving textarea (name 'properties[Name Engraving]') is never replaced, moved or renamed,
   so the cart line item property, checkout and Shopify Order Admin keep receiving exactly the same data.
   The theme file product-form.js is not modified.
   Rollback: remove the scc-pdp.js script tag from blocks/scc-pdp-intro.liquid. */
(() => {
  if (window.__sccPdpReady) return;
  window.__sccPdpReady = true;

  const FIELD = `textarea[name='properties[Name Engraving]']`;
  const TITLE = 'Make It Truly Theirs';
  const SUB = `Enter the name you'd like engraved`;
  const PLACEHOLDER = 'Enter name for engraving';
  const REMINDER = `Please double-check the spelling — we'll engrave it exactly as entered.`;

  /* Max length: single setting 'Engraving max characters' on the SIXDAYS intro block (emitted as data-engraving-max).
     If that block is absent, the server rendered maxlength attribute stays in charge. No number is hard coded here. */
  const configuredMax = () => {
    const el = document.querySelector('[data-engraving-max]');
    const n = el ? parseInt(el.getAttribute('data-engraving-max'), 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : 0;
  };

  const setText = (el, text) => {
    if (el.textContent !== text) el.textContent = text;
  };

  const ensure = (parent, cls, tag, after) => {
    let el = parent.querySelector(`:scope > .${cls}`);
    if (!el) {
      el = document.createElement(tag);
      el.className = cls;
      if (after && after.parentNode === parent) after.after(el);
      else parent.append(el);
    }
    return el;
  };

  const update = (textarea) => {
    const wrapper = textarea.parentElement;
    const count = wrapper && wrapper.querySelector(':scope > .scc-engraving__count');
    if (!count) return;
    const max = textarea.maxLength > 0 ? textarea.maxLength : 0;
    const len = textarea.value.length;
    setText(count, max ? `${len} / ${max}` : `${len}`);
    const state = max && len >= max ? 'limit' : len > 0 ? 'filled' : 'empty';
    if (wrapper.dataset.state !== state) wrapper.dataset.state = state;
  };

  const enhance = (textarea) => {
    const wrapper = textarea.parentElement;
    if (!wrapper) return;
    wrapper.classList.add('scc-engraving');

    const max = configuredMax();
    if (max && textarea.maxLength !== max) textarea.maxLength = max;

    const label = wrapper.querySelector(':scope > label');
    if (label) {
      label.classList.add('scc-engraving__title');
      setText(label, TITLE);
      setText(ensure(wrapper, 'scc-engraving__sub', 'p', label), SUB);
    }

    if (textarea.placeholder !== PLACEHOLDER) textarea.placeholder = PLACEHOLDER;
    if (textarea.getAttribute('spellcheck') !== 'false') textarea.setAttribute('spellcheck', 'false');

    const count = ensure(wrapper, 'scc-engraving__count', 'span', textarea);
    count.setAttribute('aria-hidden', 'true');
    setText(ensure(wrapper, 'scc-engraving__reminder', 'p', count), REMINDER);

    const help = wrapper.querySelector(`:scope > p:not([class*='scc-engraving'])`);
    if (help) help.classList.add('scc-engraving__help');

    if (!textarea.__sccBound) {
      textarea.addEventListener('input', () => update(textarea));
      textarea.__sccBound = true;
    }
    update(textarea);
  };

  const init = () => document.querySelectorAll(FIELD).forEach(enhance);

  /* Sticky add to cart guard. Runs in the capture phase, before the theme's own sticky click handler.
     If the existing engraving field is not valid (empty or only spaces), the click is stopped here:
     no puppet click on the main button, no Added state, no submit. We then reveal and focus the same field
     and trigger the browser's native required validation. Valid fields pass straight through untouched. */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      const button = target instanceof Element ? target.closest('.sticky-add-to-cart__button') : null;
      if (!button) return;

      const textarea = document.querySelector(FIELD);
      if (!textarea) return;

      if (textarea.value !== textarea.value.trim()) {
        textarea.value = textarea.value.trim();
        update(textarea);
      }
      if (textarea.checkValidity()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      textarea.scrollIntoView({ block: 'center' });
      textarea.focus({ preventScroll: true });
      textarea.reportValidity();
    },
    true
  );

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  };

  init();
  /* Re-apply after the theme re-renders parts of the product form (variant changes). Every write above is idempotent. */
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {
    childList: true,
    subtree: true,
  });
})();
